import { Component, OnInit, Input } from '@angular/core';
import { URLSearchParams } from '@angular/http';

import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { overlayConfigFactory } from 'angular2-modal';

import { ViewHackarootChallengeModalComponent } from './view/view.component';

import { AuthService } from '../../../../../../../providers/auth.service';
import { SharedHackService } from '../../../../../shared/services/shared-hack.service';

declare var $: any;


export class LibraryComponent implements OnInit {

	 public hackId: string;
	 public test: any;
	 public visibility: string = 'public';

	public challenges: any[];
	public tags: any[];
	public addedLibIdsMap: any = {};
	public levels: any[];

	public tagFilterIds: string[] = [];
	public levelFilter: string;

	constructor(
		public modal: Modal,
		private authService: AuthService,
		private sharedHackService: SharedHackService) { }

	// Lifecycle Events
	public ngOnInit(): void {
		this.getTags();
		this.getLibrary();
		this.getHackOverview();
		this.setLevels();
	}

	// Events
	public onViewLibraryClick(challengeId: string): void {
		let data: any = { challengeId, fromLibrary: true };
		let modalSettings: any = {
			size: 'lg',
			initData: data,
			isBlocking: false
		};
		this.modal.open(ViewHackarootChallengeModalComponent, overlayConfigFactory(modalSettings, BSModalContext))
			.then((result) => { result.result.then(() => undefined, () => undefined); });
	}

	public onRemoveLibraryClick(lib: any, challengeId: string): void {
		this.sharedHackService.deleteHackarootChallenge(String(this.authService.userId), challengeId).subscribe(
			(resp) => {
				this.getHackOverview();
			}
		);
	}

	public onAddHackarootChallengeClick(lib: any): void {
		let data = {
			library_id: lib.id,
			is_public: this.test.is_public
		};
		this.sharedHackService.postHackarootChallenge(String(this.authService.userId), this.hackId, data).subscribe(
			(resp) => {
				this.getHackOverview();
			}
		);
	}

	public onChosenChange(changes: any): void {
		if (changes && typeof changes.default !== 'undefined') {
			this.tagFilterIds = changes.default;
			this.getLibrary();
		}
	}

	public onLevelChange(changes: any): void {
		if (changes && typeof changes.default !== 'undefined') {
			this.levelFilter = changes.default;
			this.getLibrary();
		}
	}

	// Service Call
	private getTags(): void {
		this.sharedHackService.getChallengesTags(String(this.authService.userId)).subscribe(
			(tags) => {
				this.tags = tags;
			}
		);
	}

	private getLibrary(): void {
		let challengeFilters: URLSearchParams = new URLSearchParams();
		if (this.tagFilterIds.length) {
			this.tagFilterIds.map((tagId) => {
				challengeFilters.append('tags_ids[]', tagId);
			});
		}
		if (this.levelFilter) {
			challengeFilters.append('difficulty', this.levelFilter);
		}
		challengeFilters.append('visibility', this.visibility);
		this.sharedHackService.getHackarootChallengesLibrary(String(this.authService.userId), challengeFilters).subscribe(
			(challenges) => {
				this.challenges = challenges;
			}
		);
	}

	private getHackOverview(): void {
		if (this.hackId) {
			this.sharedHackService.getHack(String(this.authService.userId), this.hackId).subscribe(
				(hack) => {
					let idsObj = {};
					if (hack.hackaroot_challenges && hack.hackaroot_challenges.length) {
						hack.hackaroot_challenges.map((challenge) => {
							if (challenge.hasOwnProperty('library_id')) {
								idsObj[challenge.library_id] = challenge;
							}
						});
					}
					this.addedLibIdsMap = idsObj;
				}
			);
		}
	}

	private setLevels(): void {
		this.levels = [
			{
				value: null,
				label: 'All',
			},
			{
				value: '1',
				label: 'Level 1'
			},
			{
				value: '2',
				label: 'Level 2'
			},
			{
				value: '3',
				label: 'Level 3'
			},
			{
				value: '4',
				label: 'Level 4'
			},
			{
				value: '5',
				label: 'Level 5'
			}
		];
	}
static ctorParameters() { return [ { type: Modal }, { type: AuthService }, { type: SharedHackService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/screen-talent/test/summary/hackaroot/library/library.component.ts